<template>
  <div class="mx-auto container container--fluid">
    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table
        :headers="headers"
        :items="timetable_version_list"
        :search="search"
        class="elevation-1 mytable"
        dense
      >
        <!-- Toolbar + Add button -->
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>TimeTable Versions</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-row justify="center" dense class="mt-2">
            <v-col sm="3" md="1" cols="12"></v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>

            <!-- Add / Edit TimeTable Version dialog -->
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add TimeTable Version</v-btn>
              </template>

              <v-card>
                <v-form ref="form" v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <!-- Academic Year -->
                        <v-col cols="12" sm="6">
                          <v-autocomplete
                            v-model="editedItem.academicyear_id"
                            :items="academicYearList"
                            item-text="name"
                            item-value="id"
                            label="Academic Year"
                            :rules="[(v) => !!v || 'Academic Year is required']"
                            clearable
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title>No Academic Years loaded</v-list-item-title>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </v-col>

                        <!-- Time Table Version (Master) -->
                        <v-col cols="12" sm="6">
                          <v-autocomplete
                            v-model="editedItem.timetableversionmaster_id"
                            :items="timetableMasterList"
                            item-text="name"
                            item-value="id"
                            label="Time Table Version"
                            :rules="[(v) => !!v || 'Time Table Version is required']"
                            clearable
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title>No Time Table Versions loaded</v-list-item-title>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </v-col>

                        <!-- Version Date -->
                        <v-col cols="12" sm="6">
                          <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.version_date"
                                label="Version Date"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                                :rules="[(v) => !!v || 'Version Date is required']"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.version_date"
                              no-title
                              @input="dateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <!-- From Date (WEF) -->
                        <v-col cols="12" sm="6">
                          <v-menu
                            v-model="wefMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.wef"
                                label="From Date (WEF)"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.wef"
                              no-title
                              @input="wefMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <!-- To Date -->
                        <v-col cols="12" sm="6">
                          <v-menu
                            v-model="toMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.todate"
                                label="To Date"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.todate"
                              no-title
                              @input="toMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!-- IsCurrent -->
                        <v-col cols="12" sm="6">
                          <v-checkbox
                            v-model="editedItem.isCurrent"
                            color="success"
                            label="Is Current ?"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!-- IsLocked -->
                        <v-col cols="12" sm="6">
                          <v-checkbox
                            v-model="editedItem.islocked"
                            color="warning"
                            label="Is Locked ?"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <!-- IsCurrent column -->
        <template v-slot:item.isCurrent="{ item }">
          <v-icon v-if="item.isCurrent" color="success">mdi-check-circle-outline</v-icon>
          <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
        </template>

        <!-- IsLocked column -->
        <template v-slot:item.islocked="{ item }">
          <v-icon v-if="item.islocked" color="warning">mdi-lock</v-icon>
          <v-icon v-else color="grey">mdi-lock-open</v-icon>
        </template>

        <!-- Action column -->
        <template v-slot:item.action="{ item }">
          <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editItem(item)">edit</v-icon>
          <v-icon class="mr-2" size="25" color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>

        <!-- Linking column -->
        <template v-slot:item.linking="{ item }">
          <v-icon
            size="25"
            color="info"
            @click="openLinkingDialog(item.id)"
          >mdi-link</v-icon>
        </template>
      </v-data-table>

      <!-- Linking Dialog -->
      <v-dialog v-model="linkingDialog" max-width="1000px" persistent>
        <v-card class="linking-dialog">
          <v-toolbar dense flat color="white" class="toolbar">
            <v-toolbar-title>TimeTable Version ↔ Standard Linking</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeLinkingDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-data-table
            :headers="linkingHeaders"
            :items="linkingList"
            :search="linkingSearch"
            class="elevation-1 mytable"
            dense
          >
            <template v-slot:top>
              <v-row justify="center" dense class="mt-2">
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="linkingSearch"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>

                <!-- Add / Edit Linking dialog -->
                <v-dialog v-model="linkingFormDialog" max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mb-2 button" v-on="on" small>Add Timetable Version Linking</v-btn>
                  </template>

                  <v-card>
                    <v-form ref="linkingForm" v-model="linkingValid">
                      <v-card-title class="toolbar">
                        <span class="headline">{{ linkingFormTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <!-- TimeTable Version -->
                            <v-col cols="12" sm="6">
                              <v-autocomplete
                                v-model="editedLinkingItem.timetableversion_id"
                                :items="timeTableVersionList"
                                item-text="name"
                                item-value="id"
                                label="TimeTable Version"
                                :rules="[(v) => !!v || 'Required']"
                                clearable
                                disabled
                              ></v-autocomplete>
                            </v-col>

                            <!-- Standard -->
                            <v-col cols="12" sm="6">
                              <v-autocomplete
                                v-model="editedLinkingItem.standard_id"
                                :items="standardList"
                                item-text="name"
                                item-value="id"
                                label="Standard"
                                :rules="[(v) => !!v || 'Required']"
                                clearable
                              ></v-autocomplete>
                            </v-col>

                            <!-- Is Active -->
                            <v-col cols="12">
                              <v-checkbox
                                v-model="editedLinkingItem.isactive"
                                color="success"
                                label="Active"
                                :rules="[(v) => v !== null || 'Active status is required']"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeLinkingForm">Cancel</v-btn>
                        <v-btn color="primary" @click="saveLinking">Save</v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

            <!-- Active column -->
            <template v-slot:item.isactive="{ item }">
              <v-icon v-if="item.isactive" color="success">mdi-check-circle-outline</v-icon>
              <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
            </template>

            <!-- Action column -->
            <template v-slot:item.action="{ item }">
              <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editLinkingItem(item)">edit</v-icon>
              <v-icon size="25" color="error" @click="deleteLinkingItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>

      <!-- Loading overlay -->
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    valid: false,
    overlay: false,
    snackbar: false,
    snackbar_msg: "",
    color: "",
    search: "",
    dialog: false,
    dateMenu: false,
    wefMenu: false,
    toMenu: false,

    // TimeTable Versions table headers
    headers: [
      { text: "Academic Year", value: "academicyear_name", sortable: false },
      { text: "Time Table Version", value: "timetableversionmaster_name", sortable: false },
      { text: "Version Date", value: "version_date", sortable: true },
      { text: "From Date", value: "wef", sortable: true },
      { text: "To Date", value: "todate", sortable: true },
      { text: "Is Current ?", value: "isCurrent", sortable: false, align: "center" },
      { text: "Is Locked ?", value: "islocked", sortable: false, align: "center" },
      { text: "Actions", value: "action", sortable: false, align: "center" },
      { text: "Linking", value: "linking", sortable: false, align: "center" },
    ],

    // Linking table headers
    linkingHeaders: [
      { text: "TimeTable Version", value: "timetableversion_name", sortable: false },
      { text: "Academic Year", value: "academicyear_name", sortable: false },
      { text: "Standard", value: "standard_name", sortable: false },
      { text: "Active", value: "isactive", align: "center" },
      { text: "Created By", value: "creation_username" },
      { text: "Created On", value: "creation_date" },
      { text: "Actions", value: "action", sortable: false, align: "center" },
    ],

    // Lists from backend
    timetable_version_list: [],
    academicYearList: [],
    timetableMasterList: [],
    linkingList: [],
    timeTableVersionList: [],
    standardList: [],

    editedIndex: -1,
    editedItem: {
      id: null,
      version_date: null,
      wef: null,
      todate: null,
      isCurrent: false,
      islocked: false,
      academicyear_id: null,
      timetableversionmaster_id: null,
      organization_id: null,
    },
    defaultItem: {
      id: null,
      version_date: null,
      wef: null,
      todate: null,
      isCurrent: false,
      islocked: false,
      academicyear_id: null,
      timetableversionmaster_id: null,
      organization_id: null,
    },

    // Linking dialog data
    linkingDialog: false,
    linkingFormDialog: false,
    linkingValid: false,
    linkingSearch: "",
    selectedTimetableVersionId: null,
    editedLinkingIndex: -1,
    editedLinkingItem: {
      id: null,
      timetableversion_id: null,
      standard_id: null,
      isactive: null,
    },
    defaultLinkingItem: {
      id: null,
      timetableversion_id: null,
      standard_id: null,
      isactive: null,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New TimeTable Version" : "Edit TimeTable Version";
    },
    linkingFormTitle() {
      return this.editedLinkingIndex === -1 ? "New Linking" : "Edit Linking";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    linkingDialog(val) {
      if (!val) this.closeLinkingDialog();
    },
    linkingFormDialog(val) {
      if (!val) this.closeLinkingForm();
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    // Load TimeTable Versions data
    loadData() {
      this.overlay = true;
      axios
        .get("/timeTable/getTimeTableVersion")
        .then((res) => {
          this.overlay = false;
          if (res.data.timetable_version_list) {
            this.timetable_version_list = res.data.timetable_version_list.map((v) => ({
              ...v,
              version_date: v.version_date ? v.version_date.split("T")[0] : "",
              wef: v.wef ? v.wef.split("T")[0] : "",
              todate: v.todate ? v.todate.split("T")[0] : "",
              academicyear_name: v.academicyear_name || "",
              timetableversionmaster_name: v.timetableversionmaster_name || "",
            }));
            this.academicYearList = (res.data.academicYearList || []).sort((a, b) =>
              b.name.localeCompare(a.name)
            );
            this.timetableMasterList = res.data.timetableMasterList || [];
            if (!this.academicYearList.length || !this.timetableMasterList.length) {
              this.showSnackbar("#ff9800", "Some dropdown data is missing");
            }
          } else {
            this.handleAuthError(res.data);
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.showSnackbar("#b71c1c", "Failed to load data");
        });
    },

    // TimeTable Versions methods
    editItem(item) {
      this.editedIndex = this.timetable_version_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      if (!confirm(`Delete version dated ${item.version_date}?`)) return;

      axios
        .post("/timeTable/deleteTimeTableVersion", { deleteid: item.id })
        .then((res) => {
          if (res.data.status && res.data.status.code === "SUCCESS") {
            this.showSnackbar("#4caf50", "Version deleted");
            this.loadData();
          } else {
            this.showSnackbar("#b71c1c", res.data.status.message || "Delete failed");
          }
        })
        .catch((err) => {
          console.error(err);
          this.showSnackbar("#b71c1c", "Something went wrong");
        });
    },

    save() {
      if (!this.$refs.form.validate()) {
        this.showSnackbar("#b71c1c", "Please fill all required fields");
        return;
      }

      const payload = {
        version_date: this.editedItem.version_date,
        wef: this.editedItem.wef || null,
        todate: this.editedItem.todate || null,
        isCurrent: this.editedItem.isCurrent,
        islocked: this.editedItem.islocked,
        academicyear_id: this.editedItem.academicyear_id,
        timetableversionmaster_id: this.editedItem.timetableversionmaster_id,
        organization_id: this.editedItem.organization_id,
      };

      const url = this.editedIndex > -1
        ? "/timeTable/editTimeTableVersion"
        : "/timeTable/saveTimeTableVersion";

      if (this.editedIndex > -1) payload.editid = this.editedItem.id;

      axios
        .post(url, payload)
        .then((res) => {
          if (res.data.status && res.data.status.code === "SUCCESS") {
            this.showSnackbar("#4caf50", this.editedIndex > -1 ? "Version updated" : "Version added");
            this.loadData();
          } else if (res.data.status && res.data.status.code === "NA") {
            this.showSnackbar("#ff9800", res.data.status.message);
          } else {
            this.handleAuthError(res.data);
          }
        })
        .catch((err) => {
          console.error(err);
          this.showSnackbar("#b71c1c", "A TimeTableVersion already exists for this Academic Year and Time Table Version");
        })
        .finally(() => this.close());
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.resetValidation();
      }, 300);
    },

    // Linking dialog methods
    openLinkingDialog(timetableversion_id) {
      this.selectedTimetableVersionId = timetableversion_id;
      this.loadLinkingData(timetableversion_id);
      this.linkingDialog = true;
    },

    closeLinkingDialog() {
      this.linkingDialog = false;
      this.linkingList = [];
      this.timeTableVersionList = [];
      this.standardList = [];
      this.selectedTimetableVersionId = null;
      this.linkingSearch = "";
      this.closeLinkingForm();
    },

    loadLinkingData(timetableversion_id) {
      this.overlay = true;
      axios
        .get(`/timeTable/getTimeTableVersionLinking?timetableversion_id=${timetableversion_id}`)
        .then((res) => {
          this.overlay = false;
          if (res.data.timetable_version_linking_list) {
            this.linkingList = res.data.timetable_version_linking_list.filter(
              (item) => item.timetableversion_id === timetableversion_id
            );
            this.timeTableVersionList = res.data.timeTableVersionList || [];
            this.standardList = res.data.standardList || [];
            this.editedLinkingItem.timetableversion_id = timetableversion_id;
            this.defaultLinkingItem.timetableversion_id = timetableversion_id;
          } else {
            this.handleAuthError(res.data);
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.showSnackbar("#b71c1c", "Failed to load linking data");
        });
    },

    editLinkingItem(item) {
      this.editedLinkingIndex = this.linkingList.indexOf(item);
      this.editedLinkingItem = Object.assign({}, item);
      this.linkingFormDialog = true;
    },

    deleteLinkingItem(item) {
      if (!confirm(`Delete link for ${item.timetableversion_name} ↔ ${item.standard_name}?`)) return;
      axios
        .post("/timeTable/deleteTimeTableVersionLinking", { deleteid: item.id })
        .then((res) => {
          if (res.data.status.code === "SUCCESS") {
            this.showSnackbar("#4caf50", "Link deleted");
            this.loadLinkingData(this.selectedTimetableVersionId);
          } else {
            this.showSnackbar("#b71c1c", res.data.status.message || "Delete failed");
          }
        })
        .catch(() => this.showSnackbar("#b71c1c", "Something went wrong"));
    },

    saveLinking() {
      if (!this.$refs.linkingForm.validate()) {
        this.showSnackbar("#b71c1c", "Fill required fields");
        return;
      }

      // Ensure isactive is explicitly set
      if (this.editedLinkingItem.isactive == null) {
        this.showSnackbar("#b71c1c", "Please select Active status");
        return;
      }

      const payload = {
        timetableversion_id: this.editedLinkingItem.timetableversion_id,
        standard_id: this.editedLinkingItem.standard_id,
        isactive: this.editedLinkingItem.isactive,
      };

      const url = this.editedLinkingIndex > -1
        ? "/timeTable/editTimeTableVersionLinking"
        : "/timeTable/saveTimeTableVersionLinking";

      if (this.editedLinkingIndex > -1) payload.editid = this.editedLinkingItem.id;

      axios
        .post(url, payload)
        .then((res) => {
          if (res.data.status.code === "SUCCESS") {
            const message = this.editedLinkingIndex > -1
              ? "Link updated" + (this.editedLinkingItem.isactive ? ". Other links for this standard deactivated." : "")
              : "Link added" + (this.editedLinkingItem.isactive ? ". Other links for this standard deactivated." : "");
            this.showSnackbar("#4caf50", message);
            this.loadLinkingData(this.selectedTimetableVersionId);
          } else {
            this.showSnackbar("#ff9800", res.data.status.message || "A TimeTableVersion already exists for this Academic Year and Time Table Version");
          }
        })
        .catch(() => this.showSnackbar("#b71c1c", "Save failed"))
        .finally(() => this.closeLinkingForm());
    },

    closeLinkingForm() {
      this.linkingFormDialog = false;
      setTimeout(() => {
        this.editedLinkingItem = Object.assign({}, this.defaultLinkingItem);
        this.editedLinkingIndex = -1;
        this.$refs.linkingForm.resetValidation();
      }, 300);
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    handleAuthError(data) {
      if (data.msg && (data.msg === "401" || data.msg === "403")) {
        this.showSnackbar("#b71c1c", "Unauthorized");
      } else if (data.msg === "404") {
        this.showSnackbar("#b71c1c", data.snackbar || "User not found");
      } else {
        this.showSnackbar("#b71c1c", "A TimeTableVersion already exists for this Academic Year and Time Table Version");
      }
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.v-icon-size {
  font-size: 20px;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.linking-dialog {
  min-height: 400px;
}
</style>